import type { CSSProperties } from "react"
import {
  Compass,
  Database,
  Monitor,
  Plug,
  Smartphone,
  Sparkles,
  type LucideIcon,
} from "lucide-react"
import { useI18n } from "@/lib/i18n"

const ICONS: Record<string, LucideIcon> = {
  compass: Compass,
  monitor: Monitor,
  smartphone: Smartphone,
  plug: Plug,
  database: Database,
  sparkles: Sparkles,
}

export function ServicesStrip() {
  const { t } = useI18n()
  const items = t.hero.services
  const loop = [...items, ...items]

  return (
    <section
      aria-label="Capabilities"
      className="relative border-t border-border bg-secondary/50"
    >
      <div className="flex flex-col gap-4 py-7 md:flex-row md:items-center md:gap-8 md:py-6">
        <span className="eyebrow shrink-0 px-6 text-foreground/70 md:px-14 xl:px-20">
          // {t.nav.work === "Trabajo" ? "Capacidades" : "Capabilities"}
        </span>

        <div
          className="marquee flex-1"
          style={
            {
              "--marquee-gap": "2.25rem",
              "--marquee-duration": "45s",
              maskImage:
                "linear-gradient(to right, black 0, black calc(100% - 64px), transparent 100%)",
              WebkitMaskImage:
                "linear-gradient(to right, black 0, black calc(100% - 64px), transparent 100%)",
            } as CSSProperties
          }
        >
          <ul className="marquee-track items-center">
            {loop.map((item, i) => {
              const Icon = ICONS[item.icon] ?? Compass
              return (
                <li
                  key={`${item.label}-${i}`}
                  aria-hidden={i >= items.length}
                  className="inline-flex shrink-0 items-center gap-2 font-mono text-[11px] uppercase tracking-[0.14em] text-foreground/80"
                >
                  <Icon
                    className="size-3.5 text-primary"
                    strokeWidth={1.6}
                    aria-hidden
                  />
                  {item.label}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </section>
  )
}
